import { useEffect, useState } from "react";
import { API_BASE } from "../api/config";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import {
  FaTable,
  FaSearch,
  FaPrint,
  FaCalendarAlt,
  FaShareAlt,
  FaFileExcel,
  FaFileCsv,
  FaFilePdf,FaTimesCircle,
} from "react-icons/fa";

import {
  Banknote,
  FileDown,
  FileSpreadsheet,
  FileText,
  PlusCircle,
  Printer,
  Edit,
  XCircle,  // ✅ or Ban / CircleX / StopCircle
  Share2,
  Search,
  X,
} from "lucide-react";


function Payments() {
	  const { username, branch } = useAuth();
	  const [payments, setPayments] = useState([]);
	  const [loading, setLoading] = useState(false);
	  const [showForm, setShowForm] = useState(false);
	  const [search, setSearch] = useState("");
	  const [message, setMessage] = useState("");
	  const [paymentModes, setPaymentModes] = useState([]);
	  const [customers, setCustomers] = useState([]);
	  const [submitting, setSubmitting] = useState(false);
	  
	  const [editMode, setEditMode] = useState(false);
	  const [editTransaction, setEditTransaction] = useState(null);
  
	  const [showDeleteModal, setShowDeleteModal] = useState(false);
	  const [deleteTransactionNumber, setDeleteTransactionNumber] = useState(null);
	const [showCancelModal, setShowCancelModal] = useState(false);
	const [cancelTransactionNumber, setCancelTransactionNumber] = useState(null);
	const [cancelRemark, setCancelRemark] = useState("");
	
	
	const today = new Date().toISOString().split("T")[0]; // format: YYYY-MM-DD
	const [fromDate, setFromDate] = useState(today);
	const [toDate, setToDate] = useState(today);

	const [selectedCustomer, setSelectedCustomer] = useState("all");

  
  const navigate = useNavigate();
  
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");
  const ms = String(now.getMilliseconds()).padStart(3, "0");
  const rand = Math.floor(1000 + Math.random() * 9000);
  const transaction_number=`${yyyy}${mm}${dd}${hh}${min}${ss}${ms}${rand}`;
  const invoice_time=now.toTimeString().split(" ")[0];
   // Generate current date (YYYY-MM-DD)
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };
  const getCurrentTime = () => new Date().toTimeString().split(" ")[0];
  // Utility to generate transaction number
	const generateTransactionNumber = () => {
	  const now = new Date();
	  const yyyy = now.getFullYear();
	  const mm = String(now.getMonth() + 1).padStart(2, "0");
	  const dd = String(now.getDate()).padStart(2, "0");
	  const hh = String(now.getHours()).padStart(2, "0");
	  const min = String(now.getMinutes()).padStart(2, "0");
	  const ss = String(now.getSeconds()).padStart(2, "0");
	  const ms = String(now.getMilliseconds()).padStart(3, "0");
	  const rand = Math.floor(1000 + Math.random() * 9000);
	  return `${yyyy}${mm}${dd}${hh}${min}${ss}${ms}${rand}`;
	};
	
	 const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};
	
  const [formData, setFormData] = useState({
    invoice_date: getTodayDate(),
    invoice_time: invoice_time,
    transaction_number: transaction_number,
    payment_mode: "Cash",
    payment_mode_type: "",
    customer_id: "",
    cash: "",
    online_cash: "",
    remark: "",
    updated_by_name: username,
    branch: branch,
  });
  
   const formatDateYMD = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
  };
  
 // ✅ Call API once on page load with today's date
  useEffect(() => {
    fetchPayments(today, today);
  }, []); // empty dependency — runs only once


 // ✅ Function to fetch payments
const fetchPayments = async (from = fromDate, to = toDate) => {
  console.log("Fetching payments...", { from, to });
  

  if (!from || !to) {
    console.warn("⚠️ Missing dates, skipping fetch");
    setMessage("Please select both From and To dates.");
    return;
  }

  setLoading(true);
  setMessage("");

  try {
    const url = `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=payments&from_date=${from}&to_date=${to}&condition=get_payments_by_dates&customer_id=${selectedCustomer}&branch=${branch}`;
    console.log("Request URL:", url);

    const response = await fetch(url);

    if (!response.ok) {
      console.error("❌ HTTP error:", response.status);
      throw new Error(`HTTP ${response.status}`);
    }

    const text = await response.text();
    console.log("Raw response text:", text);

    let data;
    try {
      data = JSON.parse(text);
    } catch (err) {
      console.error("❌ JSON parse failed:", err.message);
      throw new Error("Invalid JSON returned by API");
    }

    if (Array.isArray(data) && data.length > 0) {
      console.log("✅ Payments loaded:", data.length);
      setPayments(data);
      setMessage("");
    } else {
      console.warn("⚠️ No payments found");
      setPayments([]);
      setMessage("No payments found ❌");
    }
  } catch (error) {
    console.error("❌ Error fetching payments:", error);
    setPayments([]);
    setMessage("Error loading data ❌");
  } finally {
    setLoading(false);
  }
};




  // ✅ Call fetchPayments on component mount
  useEffect(() => {
    fetchPayments();
  }, [branch]); // refetch if branch changes

  // ✅ Fetch customers for dropdown
  useEffect(() => {
    fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=accounts&condition=status`
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setCustomers(data);
        } else {
          console.error("Unexpected response format:", data);
        }
      })
      .catch((err) => console.error("Error fetching customers:", err));
  }, []);

  // ✅ Fetch Payment Modes
  useEffect(() => {
    fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=payment_modes&condition=status`
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setPaymentModes(data);
        } else {
          console.error("Unexpected response format:", data);
        }
      })
      .catch((err) => console.error("Error fetching payment modes:", err));
  }, []);

  // ✅ Clear online_cash if payment mode is Cash
  useEffect(() => {
    if (formData.payment_mode.toLowerCase() === "cash") {
      setFormData((prev) => ({ ...prev, online_cash: "" }));
    }
  }, [formData.payment_mode]);

  // ✅ Handle form input
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });
	
    const handleEdit = async (transaction_number) => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=payments&condition=get_payments_by_transaction_number&transaction_number=${transaction_number}`
      );
      const data = await res.json();
      if (data && data.length > 0) {
        const payment = data[0];
        setFormData({
          invoice_date: payment.invoice_date,
          invoice_time: payment.invoice_time,
          transaction_number: payment.transaction_number,
          payment_mode: payment.payment_mode,
          payment_mode_type: payment.payment_mode_type,
          customer_id: payment.customer_id,
          cash: payment.cash,
          online_cash: payment.online_cash,
          remark: payment.remark,
          updated_by_name: username,
          branch: branch,
        });
        setEditMode(true);
        setEditTransaction(payment.transaction_number);
        setShowForm(true);
      }
    } catch (err) {
      console.error(err);
      setMessage("❌ Error fetching payment for edit");
    }
  };	
  
  const confirmDelete = async () => {
  if (!deleteTransactionNumber) return;
  
  try {
    setMessage("Deleting...");
    const response = await fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=delete_by_transaction_number&table=transactions_list&transaction_number=${deleteTransactionNumber}`,
      { method: "GET" }
    );
    const result = await response.json();
    if (result?.status === "deleted") {
      setPayments((prev) =>
        prev.filter((p) => p.transaction_number !== deleteTransactionNumber)
      );
      setMessage("✅ Payment deleted successfully!");
    } else {
      setMessage("❌ Failed to delete payment.");
    }
  } catch (error) {
    console.error("Error deleting payment:", error);
    setMessage("❌ Something went wrong.");
  } finally {
    setShowDeleteModal(false);
    setDeleteTransactionNumber(null);
  }
};


 const handlePrint = (transaction_number) => {
    const url = `/receipt/${transaction_number}`;
    // Open receipt in a new tab
    window.open(url, "_blank");
  };


 // ✅ Submit form
   const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage(editMode ? "Updating payment..." : "Submitting...");

    try {
      const endpoint = editMode
        ? `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=payment_update&table=transactions_list`
        : `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=payment_submit&table=transactions_list`;

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (result?.status === "success") {
        await fetchPayments();
        setShowForm(false);
        setEditMode(false);
        setEditTransaction(null);
        setFormData({
          invoice_date: getTodayDate(),
          invoice_time: getCurrentTime(),
          transaction_number: generateTransactionNumber(),
          payment_mode: "Cash",
          payment_mode_type: "",
          customer_id: "",
          cash: "",
          online_cash: "",
          remark: "",
          updated_by_name: username,
          branch: branch,
        });
        setMessage(editMode ? "✅ Payment updated successfully!" : "✅ Payment added successfully!");
        setTimeout(() => setMessage(""), 4000);
      } else {
        setMessage("❌ Failed to save payment.");
      }
    } catch (err) {
      console.error(err);
      setMessage("❌ Something went wrong.");
    } finally {
      setSubmitting(false);
    }
  };

  // ✅ Search filter
  const filteredPayments = payments.filter(
    (p) =>
      p.customer_name?.toLowerCase().includes(search.toLowerCase()) ||
      p.transaction_number?.toLowerCase().includes(search.toLowerCase())
  );
  
   // Export functions
  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredPayments);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");
    XLSX.writeFile(workbook, "payments.xlsx");
  };
  
const exportPDF = () => {
  const doc = new jsPDF();

  const tableColumn = [
    "Invoice Date",
    "Transaction No",
    "Customer",
    "Payment Mode",
    "Cash",
    "Online Cash",
    "Remark",
  ];

  const tableRows = filteredPayments.map((p) => [
    p.invoice_date,
    p.transaction_number,
    p.customer_name,
    p.payment_mode,
    p.cash,
    p.online_cash,
    p.remark || "",
  ]);

  doc.text("Payments Report", 14, 15);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 20,
  });

  doc.save("payments.pdf");
};


  if (loading) {
    return (
      <Layout>
        <div className="p-6 text-center text-lg text-white">
          Loading payments...
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-white flex items-center gap-2">
            <Banknote className="w-7 h-7 text-green-400" />
            Payments
          </h1>

          <button
            onClick={() => {
  setEditMode(false);
  setEditTransaction(null);
  setFormData({
    invoice_date: getTodayDate(),
    invoice_time: getCurrentTime(),
    transaction_number: generateTransactionNumber(),
    payment_mode: "Cash",
    payment_mode_type: "",
    customer_id: "",
    cash: "",
    online_cash: "",
    remark: "",
    updated_by_name: username,
    branch: branch,
  });
  setShowForm(true);
}}
            className="flex items-center gap-2 bg-gradient-to-r from-blue-700 to-orange-500 text-white px-4 py-2 rounded-lg font-semibold hover:opacity-90 transition"
          >
            <PlusCircle className="w-5 h-5" /> Generate Payment
          </button>
        </div>
	<div className="flex flex-wrap items-center gap-3 sm:gap-4 md:gap-6 mb-6">
  {/* From Date */}
  <div className="flex items-center gap-2">
    <FaCalendarAlt />
    <input
      type="date"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
      className="border rounded p-1 text-black text-sm w-[130px] sm:w-[150px]"
    />
  </div>

  {/* To Date */}
  <div className="flex items-center gap-2">
    <FaCalendarAlt />
    <input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      className="border rounded p-1 text-black text-sm w-[130px] sm:w-[150px]"
    />
  </div>
  
  <div className="flex items-center gap-2">
  <select
    value={selectedCustomer}
    onChange={(e) => setSelectedCustomer(e.target.value)}
    className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-blue-500"
  >
    <option value="all">All</option>
    {customers.map((cust) => (
      <option key={cust.id} value={cust.id}>
        {cust.account_name} ({cust.address}, {cust.mobile_number})
      </option>
    ))}
  </select>
</div>


  {/* Fetch Button */}
  <button onClick={() => fetchPayments(fromDate, toDate)}
    className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700 transition-colors"
  >
    Fetch Data
  </button>
</div>


        {/* Search & Export */}
        <div className="flex flex-wrap justify-between items-center mb-4 gap-3">
          <div className="relative">
            <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-500" />
            <input
              type="text"
              placeholder="Search by customer or transaction..."
              className="pl-9 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-black"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
							 {/* ✅ Global Success / Error Message */}
  {message && (
    <span className="mb-4 p-3 rounded-lg text-white font-medium text-center">
      {message}
    </span>
  )}
          <div className="flex gap-2">
            <button
            onClick={exportExcel}
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:opacity-90 transition"
          >
            <FileSpreadsheet className="w-5 h-5" /> Excel
          </button>
          <CSVLink
            data={filteredPayments}
            filename={"payments.csv"}
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:opacity-90 transition"
          >
            <FileText className="w-5 h-5" /> CSV
          </CSVLink>
          <button
            onClick={exportPDF}
            className="flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-lg hover:opacity-90 transition"
          >
            <FileDown className="w-5 h-5" /> PDF
          </button>
          </div>
        </div>

        {/* Payment Table */}
        <div className="bg-white shadow-lg rounded-2xl overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="p-3 border-b">Invoice Date</th>
                <th className="p-3 border-b">Payment (₹)</th>
                <th className="p-3 border-b">Transaction No</th>
                <th className="p-3 border-b">Customer</th>
                <th className="p-3 border-b">Payment Mode</th>
                <th className="p-3 border-b">Remarks</th>
                <th className="p-3 border-b text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="text-black">
  {filteredPayments.length > 0 ? (
    filteredPayments.map((p, i) => {
      const isCancelled = Number(p.cancel_status) === 1;
      const isAdminUser =
        username?.toLowerCase() === "super admin" ||
        username?.toLowerCase() === "admin";

      return (
        <tr
          key={i}
          className={`border-b hover:bg-gray-50 transition-colors ${
            isCancelled ? "bg-red-100 opacity-75" : "text-black"
          }`}
        >
          <td className="p-3 text-black">
            {formatDate(p.invoice_date)} {p.invoice_time}
          </td>
         <td
		  className={`p-3 font-medium ${
			p.payment_mode_type === "credit"
			  ? "text-green-600"
			  : p.payment_mode_type === "debit"
			  ? "text-red-600"
			  : "text-gray-700"
		  }`}
		>
		  ₹{p.paid_amount}{" "}
		  {p.payment_mode_type === "credit"
			? "Cr"
			: p.payment_mode_type === "debit"
			? "Dr"
			: ""}
		</td>

          <td className="p-3 text-black">{p.transaction_number}</td>
         <td className="p-3 text-black">
			  {p.customer_name}{" "}
			  {p.customer_mobile && (
				<>
				  -{" "}
				  <a
					href={`tel:${p.customer_mobile}`}
					className="text-blue-600 hover:underline"
					onClick={(e) => e.stopPropagation()} // prevents row click if you have one
				  >
					{p.customer_mobile}
				  </a>
				</>
			  )}
			</td>

         <td className="p-3 text-black">
		  {p.payment_mode}
		</td>
		<td className="p-3 text-black">
		  {p.remark && (
			<span className="ml-2 text-sm text-gray-500">
			  {(p.cancel_status === 1 || p.cancel_status === "1") ? `Cancelled: ${p.remark}` : p.remark}
			</span>
		  )}
		</td>


          <td className="p-3 flex justify-center gap-3 text-black">
            {/* Always visible actions */}
            <Printer
              className="w-5 h-5 text-blue-600 cursor-pointer"
              onClick={() => handlePrint(p.transaction_number)}
            />

            {/* Hide Edit and Cancel if already cancelled */}
            {!isCancelled && (
              <>
                <Edit
                  className="w-5 h-5 text-orange-500 cursor-pointer"
                  onClick={() => handleEdit(p.transaction_number)}
                />

                {/* Cancel option visible only for admin/super admin */}
                {isAdminUser && (
                  <XCircle
                    className="w-5 h-5 text-red-600 cursor-pointer"
                    onClick={() => {
                      setCancelTransactionNumber(p.transaction_number);
                      setCancelRemark("");
                      setShowCancelModal(true);
                    }}
                  />
                )}
              </>
            )}

            {/* Always show Share */}
           <Share2
  className="w-5 h-5 text-green-500 cursor-pointer"
  onClick={() => {
    // Remove all non-digit characters
    let phone = p.customer_mobile.replace(/\D/g, "");
    
    // Ensure country code is present (example: 91 for India)
    if (!phone.startsWith("91")) {
      phone = "91" + phone;
    }

    // Receipt URL
    const url = `${window.location.origin}/receipt/${p.transaction_number}`;

    // WhatsApp link
    const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(
      "Here is your receipt: " + url
    )}`;

    // Open in new tab
    window.open(whatsappUrl, "_blank");
  }}
/>


          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={6} className="p-4 text-center text-gray-500">
        No records found.
      </td>
    </tr>
  )}
</tbody>


          </table>
        </div>
		
		{/* Totals Section */}
<div className="flex flex-col md:flex-row gap-4 mt-4">
  <div className="flex-1 bg-green-50 p-4 rounded-lg shadow">
    <h3 className="font-semibold text-green-700 mb-2">Total Credit</h3>
    <p className="text-green-600 text-lg font-medium">
      ₹{filteredPayments
        .filter(p => p.payment_mode_type === 'credit')
        .reduce((sum, p) => sum + Number(p.paid_amount), 0)}
    </p>
  </div>

  <div className="flex-1 bg-red-50 p-4 rounded-lg shadow">
    <h3 className="font-semibold text-red-700 mb-2">Total Debit</h3>
    <p className="text-red-600 text-lg font-medium">
      ₹{filteredPayments
        .filter(p => p.payment_mode_type === 'debit')
        .reduce((sum, p) => sum + Number(p.paid_amount), 0)}
    </p>
  </div>
</div>
		
		{/* Cancel Payment Modal */}
{showCancelModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 relative">
      <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
        <XCircle className="w-6 h-6 text-red-600" />
        Cancel Payment
      </h2>

      <p className="text-gray-700 mb-4">
        Please provide a reason for cancelling this payment.
      </p>

      <label className="block font-medium text-gray-700 mb-1">
        Remark <span className="text-red-500">*</span>
      </label>
      <textarea
        value={cancelRemark}
        onChange={(e) => setCancelRemark(e.target.value)}
        placeholder="Enter reason for cancellation..."
        className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-red-500"
        rows={3}
        required
      />

      <div className="flex justify-end gap-3 mt-5">
        <button
          onClick={() => setShowCancelModal(false)}
          className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold"
        >
          Close
        </button>

        <button
          onClick={async () => {
            if (!cancelRemark.trim()) {
              alert("⚠️ Please enter a remark before cancelling.");
              return;
            }
            try {
              setMessage("Cancelling...");
              const response = await fetch(
                `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=set_cancel_payment&table=transactions_list`,
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    transaction_number: cancelTransactionNumber,
                    remark: cancelRemark,
                    updated_by_name: username,
                  }),
                }
              );

              const result = await response.json();

              if (result?.status === "success") {
                setPayments((prev) =>
                  prev.map((p) =>
                    p.transaction_number === cancelTransactionNumber
                      ? { ...p, status: "Cancelled", remark: cancelRemark }
                      : p
                  )
                );
                setMessage("✅ Payment cancelled successfully!");
				 await fetchPayments();
              } else {
                setMessage("❌ Failed to cancel payment.");
              }
            } catch (error) {
              console.error("Error cancelling payment:", error);
              setMessage("❌ Something went wrong.");
            } finally {
              setShowCancelModal(false);
              setCancelTransactionNumber(null);
              setCancelRemark("");
            }
          }}
          className={`px-4 py-2 rounded-lg font-semibold text-white transition ${
            cancelRemark.trim()
              ? "bg-red-600 hover:bg-red-700"
              : "bg-gray-400 cursor-not-allowed"
          }`}
          disabled={!cancelRemark.trim()}
        >
          Confirm Cancel
        </button>
      </div>
    </div>
  </div>
)}




        {/* Add Payment Form Modal */}
        {showForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-15 z-50">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-lg p-6 relative mx-4 my-10">
              <button
                onClick={() => setShowForm(false)}
                className="absolute top-3 right-3 text-gray-500 hover:text-red-500"
              >
                <X className="w-6 h-6" />
              </button>

              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
				  {editMode ? "Update Payment" : "New Payment"}
				</h2>


              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block font-medium text-gray-700 mb-1">
                    Invoice Date
                  </label>
                  <input
                    type="date" autofocus
                    name="invoice_date"
                    value={formData.invoice_date}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block font-medium text-gray-700 mb-1">
                    Customer
                  </label>
                  <select
                    name="customer_id"
                    value={formData.customer_id}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="">Select Customer</option>
                    {customers.map((cust) => (
                      <option key={cust.id} value={`${cust.id}`}>
                        {cust.account_name} ({cust.address}, {cust.mobile_number})
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block font-medium text-gray-700 mb-1">
                    Payment Type
                  </label>
                  <select
                    name="payment_mode_type"
                    value={formData.payment_mode_type}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="credit">Credit (Income)</option>
                    <option value="debit">Debit (Expense)</option>
                  </select>
                </div>

                <div>
                  <label className="block font-medium text-gray-700 mb-1">
                    Cash (₹)
                  </label>
                  <input
                    type="number"
                    name="cash" placeholder="Enter Cash"
                    value={formData.cash}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block font-medium text-gray-700 mb-1">
                    Payment Mode
                  </label>
                  <select
                    name="payment_mode"
                    value={formData.payment_mode}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    {paymentModes.length > 0 ? (
                      paymentModes.map((mode) => (
                        <option key={mode.id} value={mode.name}>
                          {mode.name}
                        </option>
                      ))
                    ) : (
                      <option>Loading...</option>
                    )}
                  </select>
                </div>

                {/* ✅ Conditional Online Cash / Reference Field */}
                {formData.payment_mode.toLowerCase() !== "cash" &&
                  formData.payment_mode !== "" && (
                    <div>
                      <label className="block font-medium text-gray-700 mb-1">
                        Online Cash 
                      </label>
                      <input
                        type="number"
                        name="online_cash"
                        value={formData.online_cash}
                        onChange={handleChange}
                        placeholder="Enter online cash"
                        className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-blue-500"
                        required
                      />
                    </div>
                  )}
				  
				  {/* Total Paid */}
					<div>
					  <label className="block font-medium text-gray-700 mb-1">
						Total Paid (₹)
					  </label>
					  <input
						type="number"
						name="total_paid"
						value={
						  Number(formData.cash || 0) + Number(formData.online_cash || 0)
						}
						readOnly
						className="w-full border rounded-lg px-3 py-2 text-black bg-gray-100 cursor-not-allowed"
					  />
					</div>


                {/* ✅ Remarks Field */}
                <div>
                  <label className="block font-medium text-gray-700 mb-1">
                    Remarks
                  </label>
                  <textarea
                    name="remark"
                    value={formData.remark}
                    onChange={handleChange}
                    placeholder="Optional notes or details..."
                    className="w-full border rounded-lg px-3 py-2 text-black focus:ring-2 focus:ring-blue-500"
                    rows={3} required
                  />
                </div>

              <button
				  type="submit"
				  disabled={submitting}
				  className={`w-full py-2 rounded-lg font-semibold text-white ${
					submitting
					  ? "bg-gray-400 cursor-not-allowed"
					  : "bg-gradient-to-r from-blue-700 to-orange-500 hover:opacity-90 transition"
				  }`}
				>
				  {submitting
					? editMode
					  ? "Updating..."
					  : "Submitting..."
					: editMode
					? "Update Payment"
					: "Submit Payment"}
				</button>


                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="w-full bg-gray-300 text-gray-800 py-2 rounded-lg font-semibold hover:bg-gray-400 transition"
                >
                  Cancel
                </button>
              </form>

              {message && (
                <p className="mt-3 text-center text-sm font-medium text-gray-700">
                  {message}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Payments;
